/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ValidationErrorInfo {
  /**
   * Дата и время генерации ошибки
   * @format date-time
   */
  timestamp: string;

  /**
   * Сообщение об ошибки
   * @example Ошибка валидации
   */
  message: string;

  /** Код ошибки */
  errorCode: "VALIDATION_ERROR";

  /** Развернутое описание ошибки/ок */
  errorDetails: ValidationFieldInfo[];
}

/**
 * Объект для представления ошибки
 */
export interface ValidationFieldInfo {
  /**
   * Имя поля
   * @example accountNumber
   */
  fieldName: string;

  /**
   * Сообщение об ошибки
   * @example Неверный номер счета(длина не соответствует требованиям)
   */
  message: string;

  /**
   * Переданное не верное значение
   * @example 408178L0099910004312
   */
  rejectValue: string;
}

/**
 * Объект с полями бенефициара
 */
export interface Beneficiary {
  /** Имя клиента */
  clientName?: string;

  /** Название банка */
  bankName?: string;

  /** SWIFT */
  swift?: string;
}

/**
 * Объект с полями документа конверсии
 */
export interface Conversion {
  /** Тип сделки */
  transactionType?: string;

  /** Счет списания */
  writeOffAccount?: string;

  /** Сумма списания */
  writeOffAmount?: number;

  /** Валюта списания */
  writeOffCurrency?: string;

  /** Счет зачисления */
  enrollmentAccount?: string;

  /** Сумма зачисления */
  enrollmentAmount?: number;

  /** Валюта зачисления */
  enrollmentCurrency?: string;

  /**
   * Курс сделки
   * @format double
   */
  dealRate?: number;
}

/**
 * Объект для ответа о истории операций
 */
export interface DocumentListResponse {
  /** Список документов */
  documents?: DocumentResponse[];

  /** Есть ли еще документы */
  hasMore?: boolean;
}

/**
 * Список действий
 */
export interface DocumentPermission {
  /** Название операции */
  name: string;

  /** Бизнес операция согласно ролевой модели */
  operation: string;
}

/**
 * Объект с полями документов истории операций
 */
export interface DocumentResponse {
  /** ID документа */
  documentId?: string;

  /** Тип документа */
  type?: DocumentTypeEnum;

  /**
   * Дата документа
   * @format date-time
   */
  date?: string;

  /**
   * Дата создания
   * @format date-time
   */
  dateCreate?: string;

  /**
   * Номер документа
   * @format int64
   */
  number?: number;

  /** Текстовый номер документа */
  numberText?: string;

  /** Состояние документа */
  status?: string;

  /** Назначение платежа */
  purposeOperation?: string;

  /** Сумма по документу */
  amount?: number;

  /** Валюта */
  currency?: string;

  /** Наименование организации */
  name?: string;

  /** ИНН */
  inn?: string;

  /** Номер счета */
  accountNumber?: string;

  /** Номер счета клиента */
  clientAccount?: string;

  /** Номер карты */
  cardNumber?: string;

  /** Тип операции (дебет/кредит) */
  operationType?: OperationTypeEnum;

  /** Идентификатор в АБС */
  absId?: string;

  /** Код филиала */
  branch?: string;

  /** Краткое наименование подсистемы */
  systemShortName?: string;

  /** Объект с полями документа конверсии */
  conversion?: Conversion;

  /** Объект с полями документа валютного платежа */
  paymentOrderCurrency?: PaymentOrderCurrency;

  /** Распоряжение по транзитному счету */
  transitAccountOrder?: TransitAccountOrder;

  /** Список действий */
  permissions?: DocumentPermission[];

  /** Документ создан в онлайн-бухгалтерии Мое дело */
  isMyBusinessPayment?: boolean;
}

/**
 * Тип документа
 */
export enum DocumentTypeEnum {
  PAYMENT_ORDER = "PAYMENT_ORDER",
  PAYMENT_DEMAND = "PAYMENT_DEMAND",
  PAYMENT_INCASSO = "PAYMENT_INCASSO",
  CURRENCY_CONVERSION = "CURRENCY_CONVERSION",
  PAYMENT_ORDER_CURRENCY = "PAYMENT_ORDER_CURRENCY",
  TRANSIT_ACCOUNT_ORDER = "TRANSIT_ACCOUNT_ORDER",
}

/**
 * Тип операции (дебет/кредит)
 */
export enum OperationTypeEnum {
  WRITE_OFF = "WRITE_OFF",
  UNITED = "UNITED",
  INCOME = "INCOME",
}

/**
 * Объект с полями документа валютного платежа
 */
export interface PaymentOrderCurrency {
  /** Сумма списания */
  writeOffAmount?: number;

  /** Валюта списания */
  writeOffCurrency?: string;

  /** Сумма перевода */
  transferAmount?: number;

  /** Валюта перевода */
  transferCurrency?: string;

  /** Объект с полями бенефициара */
  beneficiary?: Beneficiary;
}

/**
 * Распоряжение по транзитному счету
 */
export interface TransitAccountOrder {
  /** Сумма продажи */
  saleAmount?: number;

  /** Валюта суммы продажи */
  currencySaleAmount?: string;

  /** Счет зачисления выручки */
  revenueAccount?: string;

  /** Наименование банка */
  bankName?: string;

  /** Сумма перевода */
  transferAmount?: number;

  /** Валюта суммы перевода */
  currencyTransferAmount?: string;

  /** Счет зачисления валюты */
  transferAccount?: string;

  /** Номер уведомления о поступлении средств */
  notificationNumber?: string;

  /**
   * Дата уведомления о поступлении средств
   * @format date-time
   */
  notificationDate?: string;

  /** Сумма поступления */
  receiptAmount?: number;

  /** Валюта суммы поступления на транзитный счет */
  currencyReceiptAmount?: string;
}

export interface GetDocumentsParams {
  type?: string[];
  accountNumber?: string;
  clientAccount?: string;
  statusList?: string[];
  operationTypeList?: string[];
  searchText?: string;

  /** @format int64 */
  position: number;

  /** @format int64 */
  size: number;

  /** @format date-time */
  beginDate?: string;

  /** @format date-time */
  endDate?: string;
}

export interface GetTreeLastChangedDocumentsByTypeParams {
  type: string[];
}

export interface GetDocumentsForSignParams {
  searchText?: string;
  type?: string[];
  clientAccount?: string;

  /** @format date-time */
  beginDate?: string;

  /** @format date-time */
  endDate?: string;
}

import { HttpClient } from "../../client";
import { RequestParams } from "../../client/types";

/**
 * @title Микросервис operations
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-operations.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags История операций, работа с фронтом
     * @name GetDocuments
     * @summary Получение истории
     * @request GET:/api/operations/v1/external/documents
     */
    getDocuments: (query: GetDocumentsParams, params: RequestParams = {}) =>
      this.request<DocumentListResponse, ValidationErrorInfo>({
        path: `/api/operations/v1/external/documents`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags История операций, работа с фронтом
     * @name GetTreeLastChangedDocumentsByType
     * @summary Получение последних трех измененных документов по типу документа
     * @request GET:/api/operations/v1/external/documents/three-last-changed
     */
    getTreeLastChangedDocumentsByType: (
      query: GetTreeLastChangedDocumentsByTypeParams,
      params: RequestParams = {}
    ) =>
      this.request<DocumentListResponse, ValidationErrorInfo>({
        path: `/api/operations/v1/external/documents/three-last-changed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags История операций, работа с фронтом
     * @name GetDocumentsForSign
     * @summary Получение количества документов на подпись
     * @request GET:/api/operations/v1/external/documents/for-sign-status
     */
    getDocumentsForSign: (
      query: GetDocumentsForSignParams,
      params: RequestParams = {}
    ) =>
      this.request<number, ValidationErrorInfo>({
        path: `/api/operations/v1/external/documents/for-sign-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
